module.exports = __webpack_public_path__ + "static/media/badge_326.42b89814.png";